export default "__VITE_ASSET__56b30216__"